module.exports = __webpack_public_path__ + "static/media/Step 7-Generate_Design.c08cdbf7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 7-Generate_Design.gif
// module id = 3045
// module chunks = 0